import { useStore } from '@/store';

export const getActiveTab = (): number => useStore().table.activeTab;

export const setActiveTab = (tabId: number): void => {
  useStore().setActiveTab(tabId);
};
